// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Gor0","alertIcon":"ConfirmModal_alertIcon__2gx1k"};